<script lang="ts">
  export let level: number;
</script>

<div class="player-level">
  <span class="lv">LV</span>
  <span>{level}</span>
</div>

<style>
  .player-level {
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: var(--radius-2);
    /* border: 2px solid var(--mauve-a2); */
    background-color: var(--red-a3);
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 0.8em;
    padding: var(--size-2);
  }
  .lv {
    font-size: 0.6em;
    margin-bottom: -0.4em;
  }
</style>
